var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { Box, Button, CircularProgress, FormControl, Grid, IconButton, InputAdornment, MenuItem, Paper, Select, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography, } from "@mui/material";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import CloseIcon from "@mui/icons-material/Close";
import CommonHeader from "../../components/UtilityComponents/commonHeader";
import useFillViewportHeight from "../../hooks/useFillViewportHeight";
import CommonTablePagination from "../../components/UtilityComponents/commonTablePagination";
import { colors } from "../../Themes/colors";
import { getCustomerPortalDisplayName, sortCustomerPortals, } from "../../utils/commonUtilities";
import { useLocation } from "react-router-dom";
import { api_service } from "../../api/api_service";
import { api_urls } from "../../api/api_urls";
import { utility } from "../../utils";
import constants from "../../config/constants";
var formatDateForInput = function (date) { return date.toISOString().slice(0, 10); };
var getDefaultDateRange = function () {
    var endDate = new Date();
    var startDate = new Date(endDate);
    startDate.setDate(endDate.getDate() - 30);
    return {
        fromDate: formatDateForInput(startDate),
        toDate: formatDateForInput(endDate),
    };
};
var defaultDateRange = getDefaultDateRange();
var formatTimestamp = function (timestamp) {
    var date = new Date(timestamp);
    return date.toLocaleString("en-US", {
        month: "numeric",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
        second: "2-digit",
    });
};
var escapeCsvValue = function (value) {
    if (value.includes(",") || value.includes('"') || value.includes("\n")) {
        return "\"".concat(value.replace(/"/g, '""'), "\"");
    }
    return value;
};
var getAccountTypeLabel = function (accountType) {
    if (accountType === "A")
        return "Associate";
    if (accountType === "P")
        return "Primary";
    return accountType || "-";
};
var normalizeStatus = function (response) {
    return response && response.trim() ? "Failed" : "Succeeded";
};
var mapApiRowToAuditRow = function (row, index) {
    var fallbackName = row.name || "-";
    return {
        id: String(index + 1),
        timestamp: row.createdTime || "",
        name: fallbackName,
        email: row.registeredEmail || "-",
        contractId: row.contractId || "-",
        postalCode: row.postalCode || "-",
        accountType: row.accountType || "-",
        status: normalizeStatus(row.response),
        eventType: row.accountType || "-",
        details: row.response || "-",
    };
};
var AuditLogs = function () {
    var location = useLocation();
    var _a = useState(""), searchQuery = _a[0], setSearchQuery = _a[1];
    var _b = useState(defaultDateRange.fromDate), fromDate = _b[0], setFromDate = _b[1];
    var _c = useState(defaultDateRange.toDate), toDate = _c[0], setToDate = _c[1];
    var _d = useState(""), contractIdFilter = _d[0], setContractIdFilter = _d[1];
    var _e = useState(""), emailFilter = _e[0], setEmailFilter = _e[1];
    var _f = useState(""), nameFilter = _f[0], setNameFilter = _f[1];
    var _g = useState(""), appliedSearchQuery = _g[0], setAppliedSearchQuery = _g[1];
    var _h = useState(1), currentPage = _h[0], setCurrentPage = _h[1];
    var _j = useState(50), perPageCount = _j[0], setPerPageCount = _j[1];
    var _k = useState("desc"), sortDirection = _k[0], setSortDirection = _k[1];
    var _l = useState(null), selctedPortal = _l[0], setSelectedPortal = _l[1];
    var _m = useState([]), brands = _m[0], setBrands = _m[1];
    var _o = useState([]), logs = _o[0], setLogs = _o[1];
    var _p = useFillViewportHeight(55), tableFillRef = _p.ref, tableFillMaxHeight = _p.maxHeight;
    var _q = useState(0), totalCount = _q[0], setTotalCount = _q[1];
    var _r = useState(false), isLoading = _r[0], setIsLoading = _r[1];
    var filteredRows = useMemo(function () {
        var normalized = appliedSearchQuery.trim().toLowerCase();
        var rows = normalized
            ? logs.filter(function (row) {
                return [
                    row.name,
                    row.email,
                    row.contractId,
                    row.postalCode,
                    row.accountType,
                    row.status,
                    row.eventType,
                    row.details,
                ].some(function (v) { return v != null && String(v).toLowerCase().includes(normalized); });
            })
            : logs;
        return __spreadArray([], rows, true).sort(function (a, b) {
            var aTime = new Date(a.timestamp || "").getTime();
            var bTime = new Date(b.timestamp || "").getTime();
            return sortDirection === "desc" ? bTime - aTime : aTime - bTime;
        });
    }, [logs, appliedSearchQuery, sortDirection]);
    var paginatedRows = filteredRows;
    var fetchBrands = function (cancelToken) { return __awaiter(void 0, void 0, void 0, function () {
        var response, brandsData, error_1;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, , 3]);
                    return [4, api_service.get({
                            endPoint: api_urls.CUSTOMER_PORTAL_BRAND_LIST,
                            payLoad: {},
                            showLoader: true,
                            cancelToken: cancelToken,
                        })];
                case 1:
                    response = _d.sent();
                    if ((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200) {
                        brandsData = sortCustomerPortals(response.data.data || []);
                        setBrands(brandsData);
                        if (brandsData.length > 0 && !selctedPortal) {
                            setSelectedPortal(Number(brandsData[0].Id));
                        }
                    }
                    else {
                        utility.alert(((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.message) || "Failed to fetch brands", constants.TOAST_TYPES.ERROR);
                    }
                    return [3, 3];
                case 2:
                    error_1 = _d.sent();
                    if (axios.isCancel(error_1))
                        return [2];
                    utility.alert(((_c = (_b = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
                        (error_1 === null || error_1 === void 0 ? void 0 : error_1.message) ||
                        "Failed to fetch brands", constants.TOAST_TYPES.ERROR);
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    var fetchLogs = function (page, limit) {
        if (page === void 0) { page = currentPage; }
        if (limit === void 0) { limit = perPageCount; }
        return __awaiter(void 0, void 0, void 0, function () {
            var normalizedSearchKey, payload, response, apiResponse, responseData, responseMeta, rawRows, error_2;
            var _a, _b, _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        if (!selctedPortal)
                            return [2];
                        setIsLoading(true);
                        _f.label = 1;
                    case 1:
                        _f.trys.push([1, 3, 4, 5]);
                        normalizedSearchKey = appliedSearchQuery.trim();
                        payload = __assign(__assign(__assign(__assign(__assign(__assign({ portalId: selctedPortal, page: page, limit: limit }, (fromDate && { startDate: "".concat(fromDate, "T00:00:00.000Z") })), (toDate && { endDate: "".concat(toDate, "T23:59:59.999Z") })), (contractIdFilter.trim() && { contractId: contractIdFilter.trim() })), (emailFilter.trim() && { email: emailFilter.trim() })), (nameFilter.trim() && { name: nameFilter.trim() })), (normalizedSearchKey.length >= 2 && {
                            searchKey: normalizedSearchKey,
                        }));
                        return [4, api_service.get({
                                endPoint: api_urls.CUSTOMER_PORTAL_REGISTER_LOGS,
                                payLoad: payload,
                                showLoader: false,
                            })];
                    case 2:
                        response = _f.sent();
                        if ((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200) {
                            apiResponse = response.data;
                            responseData = apiResponse.data;
                            responseMeta = Array.isArray(responseData) ? {} : responseData;
                            rawRows = Array.isArray(responseData)
                                ? responseData
                                : Array.isArray(responseData === null || responseData === void 0 ? void 0 : responseData.data)
                                    ? responseData.data
                                    : [];
                            setLogs(rawRows.map(mapApiRowToAuditRow));
                            setTotalCount((_b = (_a = apiResponse.totalCount) !== null && _a !== void 0 ? _a : responseMeta.totalCount) !== null && _b !== void 0 ? _b : rawRows.length);
                        }
                        else {
                            utility.alert(((_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.message) || "Failed to fetch audit logs", constants.TOAST_TYPES.ERROR);
                        }
                        return [3, 5];
                    case 3:
                        error_2 = _f.sent();
                        utility.alert(((_e = (_d = error_2 === null || error_2 === void 0 ? void 0 : error_2.response) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.message) ||
                            (error_2 === null || error_2 === void 0 ? void 0 : error_2.message) ||
                            "Failed to fetch audit logs", constants.TOAST_TYPES.ERROR);
                        return [3, 5];
                    case 4:
                        setIsLoading(false);
                        return [7];
                    case 5: return [2];
                }
            });
        });
    };
    useEffect(function () {
        fetchBrands();
    }, [location.key]);
    useEffect(function () {
        if (selctedPortal) {
            setCurrentPage(1);
            fetchLogs(1, perPageCount);
        }
    }, [selctedPortal]);
    useEffect(function () {
        if (selctedPortal) {
            fetchLogs(currentPage, perPageCount);
        }
    }, [currentPage, perPageCount]);
    useEffect(function () {
        if (!selctedPortal)
            return;
        var normalized = appliedSearchQuery.trim();
        if (normalized.length > 0 && normalized.length < 2)
            return;
        var timer = setTimeout(function () {
            if (currentPage !== 1) {
                setCurrentPage(1);
                return;
            }
            fetchLogs(1, perPageCount);
        }, 300);
        return function () { return clearTimeout(timer); };
    }, [appliedSearchQuery, selctedPortal]);
    var handleSearch = function () {
        setCurrentPage(1);
        fetchLogs(1, perPageCount);
    };
    var handleExport = function () {
        var headers = [
            "Date/Time",
            "Name",
            "Email",
            "Contract ID",
            "Postal Code",
            "Account Type",
            "Event Type",
            "Status",
            "Details",
        ];
        var csvRows = filteredRows.map(function (row) {
            return [
                formatTimestamp(row.timestamp || ""),
                row.name || "",
                row.email || "",
                row.contractId || "",
                row.postalCode || "",
                getAccountTypeLabel(row.accountType || ""),
                row.eventType || "",
                row.status || "",
                row.details || "",
            ]
                .map(function (value) { return escapeCsvValue(String(value)); })
                .join(",");
        });
        var csvContent = __spreadArray([headers.join(",")], csvRows, true).join("\n");
        var blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        var url = window.URL.createObjectURL(blob);
        var link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "customer-portal-audit-logs.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    };
    return (React.createElement(Box, { sx: { p: 3, bgcolor: colors.greyShades[14], minHeight: "100%" } },
        React.createElement(Stack, { spacing: 3 },
            React.createElement(Stack, { direction: { xs: "column", lg: "row" }, justifyContent: "space-between", alignItems: { xs: "flex-start", lg: "flex-start" }, spacing: 2 },
                React.createElement(CommonHeader, { mainTitle: "Audit Logs", subTitle: "Monitor failed registration and migration attempts to quickly identify and troubleshoot customer onboarding issues.", icon: React.createElement(FactCheckOutlinedIcon, { sx: { color: colors.blueShades[11], fontSize: 26 } }) }),
                React.createElement(Box, { sx: { width: { xs: "100%", sm: 240, lg: 220 }, pt: { lg: 1 } } },
                    React.createElement(FormControl, { fullWidth: true, size: "small" },
                        React.createElement(Select, { fullWidth: true, size: "small", value: selctedPortal !== null && selctedPortal !== void 0 ? selctedPortal : "", onChange: function (event) {
                                setSelectedPortal(Number(event.target.value));
                                setCurrentPage(1);
                            }, displayEmpty: true, sx: { minHeight: 40, bgcolor: colors.fullWhite } }, brands.map(function (brand) { return (React.createElement(MenuItem, { key: brand.Id, value: Number(brand.Id) }, getCustomerPortalDisplayName(brand.PortalName))); }))))),
            React.createElement(Paper, { elevation: 0, sx: {
                    py: 2.5,
                    px: { xs: 2, lg: 3 },
                    borderRadius: 2,
                    border: "1px solid ".concat(colors.greyShades[20]),
                    bgcolor: colors.fullWhite,
                } },
                React.createElement(Stack, { spacing: 2 },
                    React.createElement(Grid, { container: true, spacing: 2, alignItems: "flex-end" },
                        React.createElement(Grid, { item: true, xs: 12, sm: 6, lg: 1.7 },
                            React.createElement(TextField, { label: "Start Date", type: "date", fullWidth: true, value: fromDate, onChange: function (event) { return setFromDate(event.target.value); }, InputLabelProps: { shrink: true }, size: "small" })),
                        React.createElement(Grid, { item: true, xs: 12, sm: 6, lg: 1.7 },
                            React.createElement(TextField, { label: "End Date", type: "date", fullWidth: true, value: toDate, onChange: function (event) { return setToDate(event.target.value); }, InputLabelProps: { shrink: true }, size: "small" })),
                        React.createElement(Grid, { item: true, xs: 12, sm: 6, lg: 2.1 },
                            React.createElement(TextField, { label: "Contract ID", fullWidth: true, size: "small", value: contractIdFilter, onChange: function (event) { return setContractIdFilter(event.target.value); }, InputProps: {
                                    endAdornment: contractIdFilter ? (React.createElement(InputAdornment, { position: "end" },
                                        React.createElement(IconButton, { size: "small", onClick: function () { return setContractIdFilter(""); }, sx: { p: 0.25 } },
                                            React.createElement(CloseIcon, { fontSize: "small" })))) : null,
                                } })),
                        React.createElement(Grid, { item: true, xs: 12, sm: 6, lg: 2.1 },
                            React.createElement(TextField, { label: "Email", fullWidth: true, size: "small", value: emailFilter, onChange: function (event) { return setEmailFilter(event.target.value); }, InputProps: {
                                    endAdornment: emailFilter ? (React.createElement(InputAdornment, { position: "end" },
                                        React.createElement(IconButton, { size: "small", onClick: function () { return setEmailFilter(""); }, sx: { p: 0.25 } },
                                            React.createElement(CloseIcon, { fontSize: "small" })))) : null,
                                } })),
                        React.createElement(Grid, { item: true, xs: 12, sm: 6, lg: 2.1 },
                            React.createElement(TextField, { label: "Name", fullWidth: true, size: "small", value: nameFilter, onChange: function (event) { return setNameFilter(event.target.value); }, InputProps: {
                                    endAdornment: nameFilter ? (React.createElement(InputAdornment, { position: "end" },
                                        React.createElement(IconButton, { size: "small", onClick: function () { return setNameFilter(""); }, sx: { p: 0.25 } },
                                            React.createElement(CloseIcon, { fontSize: "small" })))) : null,
                                } })),
                        React.createElement(Grid, { item: true, xs: 12, sm: 6, lg: 2.3 },
                            React.createElement(Button, { fullWidth: true, variant: "contained", startIcon: React.createElement(SearchRoundedIcon, null), onClick: handleSearch, sx: {
                                    minHeight: 38,
                                    textTransform: "none",
                                    backgroundColor: "#000000",
                                    color: colors.fullWhite,
                                    boxShadow: "none",
                                    whiteSpace: "nowrap",
                                    "&:hover": {
                                        backgroundColor: "#000000",
                                        boxShadow: "none",
                                    },
                                } }, "Search"))),
                    React.createElement(Grid, { container: true, spacing: 2, alignItems: "center", sx: {
                            width: "100%",
                            m: 0,
                            flexWrap: { xs: "wrap", lg: "nowrap" },
                        } },
                        React.createElement(Grid, { item: true, xs: 12, lg: 10 },
                            React.createElement(TextField, { placeholder: "Filter results by any column...", fullWidth: true, size: "small", value: searchQuery, onChange: function (event) {
                                    var value = event.target.value;
                                    setSearchQuery(value);
                                    if (value.length >= 2) {
                                        setAppliedSearchQuery(value);
                                    }
                                    else {
                                        setAppliedSearchQuery("");
                                    }
                                }, InputProps: {
                                    startAdornment: (React.createElement(InputAdornment, { position: "start" },
                                        React.createElement(SearchRoundedIcon, { sx: { color: colors.greyShades[15] } }))),
                                    endAdornment: searchQuery ? (React.createElement(InputAdornment, { position: "end" },
                                        React.createElement(IconButton, { size: "small", onClick: function () {
                                                setSearchQuery("");
                                                setAppliedSearchQuery("");
                                            }, sx: { p: 0.25 } },
                                            React.createElement(CloseIcon, { fontSize: "small" })))) : null,
                                } })),
                        React.createElement(Grid, { item: true, xs: 12, sm: 6, lg: 1.9 },
                            React.createElement(Button, { fullWidth: true, variant: "outlined", startIcon: React.createElement(DownloadRoundedIcon, null), onClick: handleExport, sx: {
                                    minHeight: 40,
                                    minWidth: { xs: "100%", sm: 190 },
                                    textTransform: "none",
                                    color: colors.greyShades[13],
                                    borderColor: colors.greyShades[18],
                                    whiteSpace: "nowrap",
                                    justifyContent: "center",
                                    "&:hover": {
                                        borderColor: colors.greyShades[18],
                                        backgroundColor: colors.fullWhite,
                                    },
                                } }, "Export to CSV"))))),
            React.createElement(Paper, { elevation: 0, sx: {
                    borderRadius: 2,
                    overflow: "hidden",
                    border: "1px solid ".concat(colors.greyShades[20]),
                    display: "flex",
                    flexDirection: "column",
                } },
                React.createElement(Box, { sx: {
                        px: 2.5,
                        py: 1.5,
                        borderBottom: "1px solid ".concat(colors.greyShades[20]),
                        bgcolor: colors.fullWhite,
                    } },
                    React.createElement(Stack, { direction: { xs: "column", sm: "row" }, spacing: 1, justifyContent: "space-between", alignItems: { xs: "flex-start", sm: "center" } },
                        React.createElement(Typography, { variant: "body1", sx: { fontWeight: 600 } }, "Audit Event Stream"),
                        React.createElement(Typography, { variant: "body2", sx: { color: colors.greyShades[15] } },
                            totalCount,
                            " total records"))),
                React.createElement(TableContainer, { ref: tableFillRef, sx: {
                        flex: 1,
                        overflowY: "auto",
                        maxHeight: tableFillMaxHeight,
                    } },
                    React.createElement(Table, { sx: { minWidth: 1080 } },
                        React.createElement(TableHead, null,
                            React.createElement(TableRow, { sx: { bgcolor: colors.greyShades[11] } },
                                React.createElement(TableCell, { sx: {
                                        fontWeight: 700,
                                        cursor: "pointer",
                                        whiteSpace: "nowrap",
                                    }, onClick: function () {
                                        return setSortDirection(function (current) {
                                            return current === "desc" ? "asc" : "desc";
                                        });
                                    } },
                                    "Date/Time ",
                                    sortDirection === "desc" ? "↓" : "↑"),
                                React.createElement(TableCell, { sx: { fontWeight: 700, whiteSpace: "nowrap" } }, "Name"),
                                React.createElement(TableCell, { sx: { fontWeight: 700, whiteSpace: "nowrap" } }, "Email"),
                                React.createElement(TableCell, { sx: { fontWeight: 700, whiteSpace: "nowrap" } }, "Contract ID"),
                                React.createElement(TableCell, { sx: { fontWeight: 700, whiteSpace: "nowrap" } }, "Postal Code"),
                                React.createElement(TableCell, { sx: { fontWeight: 700, whiteSpace: "nowrap" } }, "Account Type"),
                                React.createElement(TableCell, { sx: { fontWeight: 700, minWidth: 290 } }, "Details"))),
                        React.createElement(TableBody, null, isLoading ? (React.createElement(TableRow, null,
                            React.createElement(TableCell, { colSpan: 7, sx: { py: 6, textAlign: "center" } },
                                React.createElement(CircularProgress, { size: 32 })))) : paginatedRows.length > 0 ? (paginatedRows.map(function (row) {
                            return (React.createElement(TableRow, { key: row.id, hover: true },
                                React.createElement(TableCell, { sx: { whiteSpace: "nowrap" } }, formatTimestamp(row.timestamp || "")),
                                React.createElement(TableCell, { sx: { whiteSpace: "nowrap" } }, row.name || "-"),
                                React.createElement(TableCell, null, row.email || "-"),
                                React.createElement(TableCell, { sx: { whiteSpace: "nowrap" } }, row.contractId || "-"),
                                React.createElement(TableCell, { sx: { whiteSpace: "nowrap" } }, row.postalCode || "-"),
                                React.createElement(TableCell, null, getAccountTypeLabel(row.accountType || "")),
                                React.createElement(TableCell, null, row.details || "-")));
                        })) : (React.createElement(TableRow, null,
                            React.createElement(TableCell, { colSpan: 7, sx: { py: 6, textAlign: "center" } },
                                React.createElement(Typography, { variant: "body1", sx: { fontWeight: 600, mb: 0.5 } }, "No audit events match the current filters."),
                                React.createElement(Typography, { variant: "body2", sx: { color: colors.greyShades[15] } }, "Adjust the filters or select a different portal."))))))),
                React.createElement(CommonTablePagination, { tableData: paginatedRows, currentPage: currentPage, perPageCount: perPageCount, setCurrentPage: setCurrentPage, setPerPageCount: setPerPageCount, totalNumberOfRecords: totalCount })))));
};
export default AuditLogs;
